module.exports = __webpack_public_path__ + "static/img/three.81b76ce3.png";